import { useMemo } from "react";
import type { CarPickupDropoffLocationType } from "./CarPickupDropoffLocation";
import { toMapCoordinates } from "~core-cars/utilities";

export const useCarPickupDropoffLocation = (
  props: CarPickupDropoffLocationType
) => {
  const hasSamePickupDropoff = useMemo(() => {
    return (
      props.car.pickUp.coordinates.lat === props.car.dropOff.coordinates.lat &&
      props.car.pickUp.coordinates.lon === props.car.dropOff.coordinates.lon
    );
  }, [
    props.car.dropOff.coordinates.lat,
    props.car.dropOff.coordinates.lon,
    props.car.pickUp.coordinates.lat,
    props.car.pickUp.coordinates.lon,
  ]);

  return {
    context: {
      pickUpDirections: props.pickUpDirections,
      pickupAddress: props.car.pickUp.address,
      dropoffAddress: props.car.dropOff.address,
      map: {
        pickup: toMapCoordinates(props.car.pickUp.coordinates),
        ...(hasSamePickupDropoff
          ? {}
          : { dropOff: toMapCoordinates(props.car.dropOff.coordinates) }),
      },
      dropoffTime: props.car.dropOff.time,
      pickUpTime: props.car.pickUp.time,
    },
  };
};
